import { useMutation } from "@tanstack/react-query";
import { companiesService } from "@/services/companiesService";

// Mutation keys
export const companyMutationKeys = {
  create: "createCompany",
  update: "updateCompany",
  delete: "deleteCompany",
};

// Create a new company
export const useCreateCompany = (options) =>
  useMutation({
    mutationKey: companyMutationKeys.create,
    mutationFn: (companyData) => companiesService.createCompany(companyData),
    ...options,
});

// Update a company
export const useUpdateCompany = (options) =>
  useMutation({
    mutationKey: companyMutationKeys.update,
    mutationFn: ({companyId, companyData}) => {
      return companiesService.updateCompany(companyId, companyData);
    },
    ...options,
  });

  // delete company
  export const useDeleteCompany = (options) =>
  useMutation({
    mutationKey: companyMutationKeys.delete,
    mutationFn: (companyId) => companiesService.deleteCompany(companyId),
    ...options,
  });
  
